import React, { useState, useEffect } from "react";
import { Table, Space, Row, Col, Input, Select, Button, Modal, notification, Tooltip, Pagination, Tag, Badge } from "antd";
import { DeleteOutlined, EditOutlined, EyeOutlined, SearchOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { dropdownService, vehicleService } from "../../../services";
import { checkPermission } from '../../../utils/permissions';
import { AiOutlineExport } from "react-icons/ai";
import ExportModal from "./ExportModal";
import { useDebounce } from "../../../hooks/useDebounce";
import { LuFolderSearch2, LuTruck } from "react-icons/lu";
import { FaRegFileAlt } from "react-icons/fa";
import { HiOutlineCheckCircle } from "react-icons/hi";
import { GiReturnArrow } from "react-icons/gi";
import { changeDocumentTitle } from "../../../utils/title";
import CardSkeleton from "../../../utils/skeleton";
import { withDefaultRender } from "../../../utils/tableDefaultRender";
import { CiFilter } from "react-icons/ci";
import AdvancedFilter from "../../../components/AdvancedFilter";

function Vechical() {
  const [isExportModalVisible, setIsExportModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [vehicles, setVehicles] = useState([]);
  const [updatedColumns, setUpdatedColumns] = useState([]);
  const [selectedRecord, setSelectedRecord] = useState();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [search, setSearch] = useState(null)
  const [status, setStatus] = useState([])
  const [pagination, setPagination] = useState({
    current: 1,
    total: 0,
    pageSize: 10,
  });
  const [showFilters, setShowFilters] = useState(false);
  const [filterValues, setFilterValues] = useState({});

  const debouncedSearch = useDebounce(search, 500);

  const [customer, setCustomer] = useState([])
  const [destination, setDestination] = useState([])
  const [allVehicle, setAllVehicle] = useState([])

  const showExportModal = () => {
    setIsExportModalVisible(true);
  };
  const handleExportCancel = () => {
    setIsExportModalVisible(false);
  };

  const handleExportConfirm = () => {
    setIsExportModalVisible(false);
  };

  const startYear = 1990;
  const endYear = new Date().getFullYear();

  const yearOptions = [];
  for (let y = endYear; y >= startYear; y--) {
    yearOptions.push({ label: String(y), value: String(y) });
  }

  const uniqueVehicleOptions = [
    { label: "All", value: null },
    ...Array.from(
      new Map(
        allVehicle.map(v => [v.vehicle.trim(), v.vehicle.trim()])
      ).values()
    ).map(vehicle => ({
      label: vehicle,
      value: vehicle,
    })),
  ];


  const columns = withDefaultRender([
    {
      title: "Id",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Customer",
      dataIndex: "customer_name",
      key: "customer_name",
      render: (text, record) => {
        if (!text) return "";

        const formattedName = text
          .split(" ")
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");

        return (
          <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <span>{formattedName}</span>

            {record?.is_globex_vehicle === 1 && (
              <Tag color="#3dabce" style={{ fontSize: 8 }}>
                GLOBEX
              </Tag>
            )}
          </div>
        );
      },
    },
    {
      title: "Car Status",
      dataIndex: "car_status",
      key: "car_status",
      render: (text) => (
        <>
          {text === "LOADED" ? <Tag color="green">{text}</Tag> : text === "AT YARD" ? <Tag color="gold">{text}</Tag> : text === "IN LOAD PLAN" ? <Tag color="blue">{text}</Tag> : text === "RETURNED" ? <Tag color="red">{text}</Tag> : null}
        </>
      )
    },
    {
      title: "Free Days",
      dataIndex: "storage_days",
      key: "storage_days",
      // render: (value) => value ? value : "-",
    },
    {
      title: "Per Day Charges($)",
      dataIndex: "storage_charges",
      key: "storage_charges",
      // render: (value) => value ? value : "-",
    },
    {
      title: "Days Left",
      dataIndex: "leftDays",
      key: "leftDays",
      // render: (value) => value ? value : "-",
    },
    {
      title: "Storage Charges($)",
      dataIndex: "StorageCharges",
      key: "StorageCharges",
      // render: (value) => value ? value : "-",
    },
    // {
    //   title: "Lot No",
    //   dataIndex: "lot_#",
    //   key: "lot_#",
    //   // render: (text) => text || "-"
    // },
    {
      title: "Title Available",
      dataIndex: "title",
      key: "title",
      render: (value) => value ? value : "-",
    },
    {
      title: "Destination",
      dataIndex: "destination",
      key: "destination",
      render: (value) => value ? value : "-",
    },
    {
      title: "Vehicle",
      dataIndex: "vehicle",
      key: "vehicle",
      render: (value) => value ? value : "-",
    },
    {
      title: "Model",
      dataIndex: "product",
      key: "product",
      render: (value) => value ? value : "-",
    },
    {
      title: "Year",
      dataIndex: "year",
      key: "year",
    },
    {
      title: "Chassis No",
      dataIndex: "chasis_no",
      key: "chasis_no",
    },
    {
      title: "File Ref No",
      dataIndex: "file_ref",
      key: "file_ref",
    },
    {
      title: "Invoice No",
      dataIndex: "invoice_no",
      key: "invoice_no",
      render: (text) =>
        text === null ? (
          <span className="text-[#BFBFBF]">
            Not Issued
          </span>
        ) : (
          <a
            href={`/invoice/view/${text}`}
            target="_blank"
            rel="noopener noreferrer"
            className="underline text-primary hover:text-primary hover:underline"
          >
            {text}
          </a>
        ),
    },
    {
      title: "Action",
      key: "Action",
      fixed: "right",
      render: (text, record, { _id }) => (
        <Space size="small">
          <Link to={`/vehicle/edit/${record.id}`} className="hover:text-primary">
            <Tooltip title="Edit">
              {/* <Button type="primary" size="small" > */}
              <EditOutlined />
              {/* </Button> */}
            </Tooltip>
          </Link>

          <Link to={`/vehicle/${record.id}`} className="hover:text-primary">
            <Tooltip title="View">
              {/* <Button type="primary" size="small"> */}
              <EyeOutlined />
              {/* </Button> */}
            </Tooltip>
          </Link>

          {checkPermission("DELETE_VEHICLE") && <Tooltip title="Delete">
            {/* <Button type="primary" size="small" onClick={() => showModal(record)}> */}
            <DeleteOutlined onClick={() => showModal(record)} />
            {/* </Button> */}
          </Tooltip>}
        </Space>
      ),
    },
  ])

  const showModal = (record) => {
    setSelectedRecord(record);
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setSelectedRecord(null);
  };

  const handleOk = async () => {
    if (!selectedRecord) return;
    setDeleteLoading(true);
    const response = await vehicleService.deleteVehicle(selectedRecord.id);
    if (response?.success) {
      notification.success({
        message: "Deleted Successfully",
        description: response.message,
        placement: "topRight",
      });
      setIsModalVisible(false);
      initialize();
    }
    setDeleteLoading(false);
    setSelectedRecord(null);
  };

  const initialize = async (page = 1, pageSize = pagination.pageSize) => {
    try {
      setLoading(true);
      const { success, data, message } = await vehicleService.getVehicles(page, debouncedSearch, filterValues);

      if (success) {
        if (data && data.vehicles && data.vehicles.data.length > 0) {
          setVehicles(data?.vehicles?.data);
          setStatus(data.status_counts)

          //   const allowedColumns = [
          //     "lot_#",
          //     "destination",
          //     "vehicle",
          //     "product",
          //     "year",
          //     "chasis_no",
          //     "invoice_no"
          //   ];
          //    const filteredBackendColumns = data.columns
          //   .filter(column => allowedColumns.includes(column));

          // const mappedColumns = filteredBackendColumns.map((column) => ({
          //   title: column
          //     .replace(/_/g, " ")
          //     .replace(/\b\w/g, (char) => char.toUpperCase()),
          //   dataIndex: column,
          //   key: column,
          //   render: (value) => {
          //     if (!value) return "-";
          //     return column === "product" || column === "operating_port"
          //       ? value
          //         .toLowerCase()
          //         .split(" ")
          //         .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          //         .join(" ")
          //       : value;
          //   },
          // }));

          // // ✅ Insert backend columns after "Storage Charges"
          // const storageChargesIndex = columns.findIndex(col => col.key === "StorageCharges");
          // const updatedColumnsTemp = [...columns];

          // if (storageChargesIndex !== -1) {
          //   updatedColumnsTemp.splice(storageChargesIndex + 1, 0, ...mappedColumns);
          // }

          // setUpdatedColumns(updatedColumnsTemp);


          // Merge hardcoded columns with backend columns
          // const filteredBackendColumns = data.columns.filter(column => column !== "id");

          // const mappedColumns = filteredBackendColumns.map((column) => ({
          //   title: column.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase()),
          //   dataIndex: column,
          //   key: column,
          //   render: (value) => {
          //     if (!value) return "-";
          //     return column === "product" || column === "operating_port"
          //       ? value
          //         .toLowerCase()
          //         .split(" ")
          //         .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          //         .join(" ")
          //       : value;
          //   },
          // }));


          // const storageChargesIndex = columns.findIndex(col => col.key === "StorageCharges");
          // const updatedColumnsTemp = [...columns];

          // if (storageChargesIndex !== -1) {
          //   updatedColumnsTemp.splice(storageChargesIndex + 1, 0, ...mappedColumns);
          // }

          // setUpdatedColumns(updatedColumnsTemp);

          setPagination((prev) => ({
            ...prev,
            total: data.vehicles.total,
            current: page,
            pageSize,
          }));
        } else {
          console.warn("No vehicles data found.");
          setVehicles([]); // Clear vehicle list if no data is present
        }
      } else {
        console.error(`Error: ${message || "Failed to fetch vehicles."}`);
      }
    } catch (error) {
      console.error("An unexpected error occurred:", error);
    } finally {
      setLoading(false);
    }
  };

  const cardData = [
    { title: 'Total Vehicles', count: Number(status?.TOTAL_VEHICLES || 0).toLocaleString(), imgSrc: <LuTruck style={{ padding: 6, backgroundColor: "#FDE5E7", color: "#C10007", fontSize: "44px", borderRadius: "8px" }} />, },
    { title: 'In Load Plans', count: Number(status?.IN_LOAD_PLAN || 0).toLocaleString(), imgSrc: <FaRegFileAlt style={{ padding: 6, backgroundColor: "#FDE5E7", color: "#C10007", fontSize: "44px", borderRadius: "8px" }} />, },
    { title: 'Loaded', count: Number(status?.LOADED || 0).toLocaleString(), imgSrc: <HiOutlineCheckCircle style={{ padding: 4, backgroundColor: "#FDE5E7", color: "#C10007", fontSize: "44px", borderRadius: "8px" }} /> },
    { title: 'At Yard', count: Number(status?.AT_YARD || 0).toLocaleString(), imgSrc: <LuFolderSearch2 style={{ padding: 6, backgroundColor: "#FDE5E7", color: "#C10007", fontSize: "44px", borderRadius: "8px" }} /> },
    { title: 'Returned', count: Number(status?.RETURNED || 0).toLocaleString(), imgSrc: <GiReturnArrow style={{ padding: 6, backgroundColor: "#FDE5E7", color: "#C10007", fontSize: "44px", borderRadius: "8px" }} /> },
  ];

  const deleteModal = (
    <>
      <Modal
        title={<div style={{ textAlign: "center" }}>Confirm</div>}
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        centered
        style={{
          padding: "20px",
        }}
        width={300}
        footer={
          <div className="flex justify-center gap-3">
            <Button
              type="default"
              onClick={handleCancel}
              style={{ width: "30%" }}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              onClick={handleOk}
              loading={deleteLoading}
            >
              Confirm
            </Button>
          </div>
        }
      >
        <p style={{ textAlign: "center" }}>
          Are you sure you want to delete this?
        </p>
      </Modal>
    </>
  )
  const allCustomer = async () => {
    const response = await dropdownService.fetchCustomers()
    if (response?.success) {
      setCustomer(response.data)
    }

  }

  const allDestination = async () => {
    const response = await dropdownService.fetchDestination()
    if (response?.success) {
      setDestination(response.data)
    }
  }

  const fetchAllVehicle = async () => {
    const response = await dropdownService.fetchVehicles()
    if (response?.success) {
      setAllVehicle(response.data)
    }
  }

  const vehicleFilters = [
    {
      name: "user_id",
      label: "Customer",
      options: customer.map(cust => ({ label: cust.name, value: cust.id })),
    },
    {
      name: "car_status",
      label: "Car Status",
      options: [
        { label: "Loaded", value: "LOADED" },
        { label: "At Yard", value: "AT YARD" },
        { label: "In Load Plan", value: "IN LOAD PLAN" },
        { label: "Returned", value: "RETURNED" },
      ],
    },
    {
      name: "year",
      label: "Year",
      options: yearOptions
    },
    {
      name: "vehicle",
      label: "Vehicle",
      options: uniqueVehicleOptions
    },
    {
      name: "destination",
      label: "Destination",
      options: destination.map(dest => ({ label: dest.name, value: dest.name }))
    },
  ];

  const handleFilterChange = (name, value) => {
    setFilterValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleResetFilters = () => {
    setFilterValues({});
    initialize(1, pagination.pageSize);
  };

  const activeFilterCount = Object.values(filterValues).filter(Boolean).length;


  useEffect(() => {
    changeDocumentTitle("Vehicles");
    allCustomer();
    allDestination();
    fetchAllVehicle();
  }, []);

  // Run ONLY when filters/search change
  useEffect(() => {
    initialize(pagination.current, pagination.pageSize);
  }, [debouncedSearch, filterValues]);
  return (
    <>
      
        <div gutter={[24, 24]} className="flex gap-5 mb-6">
          {cardData.map((data, index) => (
            <div className='p-3 bg-white w-full border-[#D9D9D9] border-2 rounded-xl'>
              {loading ?
                <CardSkeleton />
                :
                <div className="flex gap-5 ">
                  {data.imgSrc}
                  <div className=''>
                    <h1 className='text-[11px]'>{data.title}</h1>
                    <h2 className="text-3xl">{data.count}</h2>
                  </div>
                </div>
              }

            </div>
          ))}
        </div>
      <div style={{ padding: "20px", border: "1px solid #ccc", borderRadius: "8px", backgroundColor: "#FFFFFF" }}>
        
            <div className="flex items-center gap-2">
              <Input
                placeholder="Search by Vehicle & Chassis no"
                prefix={<SearchOutlined />}
                style={{
                  width: "70%",
                  height: "45px",
                  borderRadius: "5px",
                  fontSize: 14,
                  margin: 10
                }}
                onChange={(e) => setSearch(e.target.value)}
              />
              <div className="flex gap-2">
                <Badge count={activeFilterCount}>
                  <Button icon={<CiFilter style={{ fontSize: 22 }} />} className="h-11" type={showFilters ? 'primary' : 'default'} onClick={() => setShowFilters(prev => !prev)}
                  >Advanced Filter </Button>
                </Badge>
                {
                  checkPermission('EXPORT_VEHICLE') &&
                  <Tooltip title="Export">
                    <Button type="primary" size="middle" onClick={() => showExportModal()} className="h-11">
                      Export
                      <AiOutlineExport style={{ fontSize: "14px" }} />
                    </Button>
                  </Tooltip>
                }
              </div>
            </div>
            <div className="p-3">
              <AdvancedFilter
                visible={showFilters}
                filters={vehicleFilters}
                values={filterValues}
                onChange={handleFilterChange}
                onReset={handleResetFilters}
              />
            </div>

        <Table
          columns={columns}
          dataSource={vehicles}
          loading={loading}
          rowKey="id"
          scroll={{ x: "max-content" }}
          // pagination={{
          //   current: pagination.current,
          //   total: pagination.total,
          //   pageSize: pagination.pageSize,
          //   onChange: (page) => initialize(page, pagination.pageSize),
          //   showSizeChanger: false,
          // }}
          pagination={false}
          style={{ marginTop: "10px" }}
          footer={() => (
            <div className="flex justify-between items-center text-xs ">
              <div className=" text-gray-600">
                Showing {(pagination.current - 1) * pagination.pageSize + 1} to{" "}
                {Math.min(pagination.current * pagination.pageSize, pagination.total)} of{" "}
                {pagination.total} entries
              </div>
              <Pagination
                current={pagination.current}
                total={pagination.total}
                pageSize={pagination.pageSize}
                showSizeChanger={false}
                onChange={(page) => initialize(page, pagination.pageSize, search)}
                itemRender={(current, type, originalElement) => {
                  if (type === "prev") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Previous</a>;
                  if (type === "next") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Next</a>;
                  return originalElement;
                }}
              />
            </div>
          )}
        />

        {/* Delete Modal */}
        {deleteModal}
        <ExportModal
          isVisible={isExportModalVisible}
          onCancel={handleExportCancel}
          onConfirm={handleExportConfirm}
        />
      </div>
    </>
  );
}

export default Vechical;
